module.exports = __webpack_public_path__ + "img/Stemness-LUCA_10X_LU.5a635003.png";